interface FilterItemProps {
  isActive?: boolean;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  children: React.ReactNode;
}

export default function FilterItem({
  isActive,
  onClick,
  children,
}: FilterItemProps) {
  return (
    <li className='mr-2 mb-2'>
      <a
        className={`block cursor-pointer rounded-md px-3 py-2 ${
          isActive
            ? 'bg-primary-500 text-white'
            : 'bg-slate-50 dark:bg-slate-700/50 dark:text-slate-200'
        }`}
        onClick={onClick}
      >
        {children}
      </a>
    </li>
  );
}
